import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';

// Route guards
import ProtectedRoute from './components/ProtectedRoute';
import GuestRoute     from './components/GuestRoute';

// Layout
import AppLayout from './components/layout/AppLayout';

// Auth pages
import LoginPage    from './pages/auth/LoginPage';
import RegisterPage from './pages/auth/RegisterPage';

// App pages
import DashboardPage          from './pages/DashboardPage';
import TransactionHistoryPage from './pages/TransactionHistoryPage';
import InvestPage         from './pages/InvestPage';
import WithdrawPage       from './pages/WithdrawPage';
import NotificationsPage  from './pages/NotificationsPage';
import ProfilePage        from './pages/profile/ProfilePage';
import EditProfilePage    from './pages/profile/EditProfilePage';
import UploadPhotoPage    from './pages/profile/UploadPhotoPage';
import BankDetailsPage    from './pages/profile/BankDetailsPage';
import NomineeDetailsPage       from './pages/profile/NomineeDetailsPage';
import IdProofPage               from './pages/profile/IdProofPage';
import WithdrawalTransferPage    from './pages/profile/WithdrawalTransferPage';
import ContactPage               from './pages/ContactPage';
import PoliciesIndexPage         from './pages/policies/PoliciesIndexPage';
import TermsPage                 from './pages/policies/TermsPage';
import RefundPage                from './pages/policies/RefundPage';
import PrivacyPage               from './pages/policies/PrivacyPage';
import ShippingPage              from './pages/policies/ShippingPage';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Public routes */}
          <Route path="/contact"           element={<ContactPage />} />

          {/* Public policy routes */}
          <Route path="/policies"          element={<PoliciesIndexPage />} />
          <Route path="/policies/terms"    element={<TermsPage />} />
          <Route path="/policies/refund"   element={<RefundPage />} />
          <Route path="/policies/privacy"  element={<PrivacyPage />} />
          <Route path="/policies/shipping" element={<ShippingPage />} />

          {/* Guest-only routes */}
          <Route element={<GuestRoute />}>
            <Route path="/login"    element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
          </Route>

          {/* Protected routes — wrapped in AppLayout */}
          <Route element={<ProtectedRoute />}>
            <Route element={<AppLayout />}>
              <Route path="/dashboard"            element={<DashboardPage />} />
              <Route path="/transactions"        element={<TransactionHistoryPage />} />
              <Route path="/invest"           element={<InvestPage />} />
              <Route path="/withdraw"         element={<WithdrawPage />} />
              <Route path="/notifications"    element={<NotificationsPage />} />
              <Route path="/profile"          element={<ProfilePage />} />
              <Route path="/profile/edit"     element={<EditProfilePage />} />
              <Route path="/profile/photo"    element={<UploadPhotoPage />} />
              <Route path="/profile/bank"     element={<BankDetailsPage />} />
              <Route path="/profile/nominee"  element={<NomineeDetailsPage />} />
              <Route path="/profile/id-proof"  element={<IdProofPage />} />
              <Route path="/profile/transfers" element={<WithdrawalTransferPage />} />
            </Route>
          </Route>

          {/* Fallback */}
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
